// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import type { PastFilter } from '../../services/planSelectors';

export type PastSort = 'newest' | 'oldest';

const FILTERS: { key: PastFilter; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'approved', label: 'Approved' },
  { key: 'rejected', label: 'Rejected' },
  { key: 'expired', label: 'Expired' },
];

const SORTS: { key: PastSort; label: string }[] = [
  { key: 'newest', label: 'Newest' },
  { key: 'oldest', label: 'Oldest' },
];

/**
 * Outcome filter chips (with counts) and the Newest/Oldest sort for the Past
 * recommendations tab (AB#34850). Same chip and segmented controls as the Home
 * alarm list, so the two screens read alike. Controlled.
 */
export default function PastListControls({
  filter,
  sort,
  counts,
  onFilterChange,
  onSortChange,
}: {
  filter: PastFilter;
  sort: PastSort;
  counts: Record<PastFilter, number>;
  onFilterChange: (_filter: PastFilter) => void;
  onSortChange: (_sort: PastSort) => void;
}) {
  return (
    <div className="hs-past-controls">
      <div className="hs-group-pills" role="group" aria-label="Filter by outcome">
        {FILTERS.map(f => (
          <button
            key={f.key}
            type="button"
            className={`hs-group-pill${filter === f.key ? ' active' : ''}`}
            aria-pressed={filter === f.key}
            onClick={() => onFilterChange(f.key)}
          >
            {f.label} <span className="hs-pill-count">{counts[f.key]}</span>
          </button>
        ))}
      </div>
      <div className="hs-segmented" role="group" aria-label="Sort order">
        {SORTS.map(o => (
          <button
            key={o.key}
            type="button"
            className={`hs-pill${sort === o.key ? ' active' : ''}`}
            aria-pressed={sort === o.key}
            onClick={() => onSortChange(o.key)}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
